<template>
  <div class="camera-manage-container">
    <!-- Tab切换 -->
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="申请查看" name="apply"></el-tab-pane>
      <el-tab-pane label="摄像头列表" name="list"></el-tab-pane>
      <el-tab-pane label="摄像头设置" name="setting"></el-tab-pane>
    </el-tabs>

    <!-- 摄像头设置 -->
    <div v-if="activeName === 'setting'" class="setting-content" key="setting-content">
      <!-- 基础配置（可折叠） -->
      <el-card class="setting-card">
        <div slot="header" class="card-header collapsible" @click="toggleBasicConfig">
          <span>基础配置</span>
          <i :class="basicConfigCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" class="collapse-icon"></i>
        </div>
        
        <el-collapse-transition>
          <div v-show="!basicConfigCollapsed">
            <el-form ref="settingForm" :model="settingForm" :rules="settingRules" label-width="150px" size="small">
              <el-form-item label="是否开启" prop="status">
                <el-switch
                  v-model="settingForm.status"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="开启"
                  inactive-text="关闭">
                </el-switch>
              </el-form-item>

              <el-form-item label="AppKey" prop="AppKey">
                <el-input v-model="settingForm.AppKey" placeholder="请输入AppKey" clearable>
                  <template slot="append">
                    <el-button type="text" @click="generateAppKey">生成</el-button>
                  </template>
                </el-input>
              </el-form-item>

              <el-form-item label="Secret" prop="Secret">
                <el-input v-model="settingForm.Secret" type="password" placeholder="请输入Secret" show-password clearable>
                  <template slot="append">
                    <el-button type="text" @click="generateSecret">生成</el-button>
                  </template>
                </el-input>
              </el-form-item>

              <el-form-item label="AccessToken" prop="AccessToken">
                <el-input v-model="settingForm.AccessToken" placeholder="请输入AccessToken" clearable>
                  <template slot="append">
                    <el-button type="text" @click="refreshToken">刷新</el-button>
                  </template>
                </el-input>
              </el-form-item>

              <el-form-item label="测试地址" prop="test_url">
                <el-input
                  v-model="settingForm.test_url"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入测试地址"
                  clearable>
                </el-input>
              </el-form-item>

              <el-form-item label="回调地址" prop="callback_url">
                <el-input
                  v-model="settingForm.callback_url"
                  placeholder="请输入回调地址"
                  clearable>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </el-card>

      <!-- 申请查看时长设置 -->
      <el-card class="duration-card">
        <div slot="header" class="card-header">
          <span>申请查看时长设置</span>
        </div>
        <el-form ref="durationForm" :model="settingForm" label-width="150px" size="small">
          <el-form-item label="申请查看有效时长" prop="valid_duration">
            <el-input-number 
              v-model="settingForm.valid_duration" 
              :min="1" 
              :max="525600" 
              placeholder="请输入有效时长"
              style="width: 200px"
            >
              <template slot="append">分钟</template>
            </el-input-number>
            <div style="color: #909399; font-size: 12px; margin-top: 5px;">
              设置申请通过后的有效查看时长（1分钟 - 1年）
            </div>
            <div style="color: #67C23A; font-size: 12px; margin-top: 5px;">
              当前设置：{{ formatDuration(settingForm.valid_duration) }}
            </div>
          </el-form-item>
        </el-form>
      </el-card>

      <!-- 公用保存按钮 -->
      <el-card class="action-card">
        <div class="action-buttons">
          <el-button type="primary" @click="saveSetting" :loading="settingLoading">保存配置</el-button>
          <el-button @click="resetSetting">重置</el-button>
          <el-button type="success" @click="testConnection">测试连接</el-button>
        </div>
      </el-card>

      <!-- 配置说明（可折叠） -->
      <el-card class="info-card">
        <div slot="header" class="card-header collapsible" @click="toggleInfoConfig">
          <span>配置说明</span>
          <i :class="infoConfigCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" class="collapse-icon"></i>
        </div>
        
        <el-collapse-transition>
          <div v-show="!infoConfigCollapsed" class="info-content">
            <p>1. AppKey 和 Secret 用于身份验证，请妥善保管</p>
            <p>2. AccessToken 用于API调用，定期刷新以保证安全</p>
            <p>3. 测试地址用于验证摄像头连接状态</p>
            <p>4. 回调地址用于接收摄像头事件通知</p>
            <p>5. 申请查看有效时长：设置用户申请通过后可以查看摄像头的时长</p>
          </div>
        </el-collapse-transition>
      </el-card>
    </div>

    <!-- 其他部分保持不变 -->
    <!-- 摄像头列表 -->
    <div v-if="activeName === 'list'" class="list-content" key="list-content">
      <!-- 搜索区域 -->
      <el-card class="search-card">
        <el-form :inline="true" :model="searchForm" size="small" class="search-form">
          <el-form-item label="摄像头名称">
            <el-input v-model="searchForm.name" placeholder="请输入摄像头名称" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item label="摄像头类型">
            <el-select v-model="searchForm.type" placeholder="请选择类型" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="平台摄像头" value="1"></el-option>
              <el-option label="工厂摄像头" value="2"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="摄像头状态">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="开启" value="1"></el-option>
              <el-option label="关闭" value="0"></el-option>
              <el-option label="未知" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <!-- 操作按钮 -->
      <el-card class="action-card">
        <div class="action-buttons">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">添加摄像头</el-button>
          <el-button type="success" icon="el-icon-refresh" size="small" @click="refreshList">刷新</el-button>

          <div class="camera-count-info">
            <el-tag type="info" size="small">
              已添加: {{ cameranum.camera_num || 0 }}/{{ cameranum.user_sxt||0 }}
            </el-tag>
          </div>
        </div>
      </el-card>

      <!-- 摄像头列表 -->
      <el-card>
        <el-table
          v-loading="listLoading"
          :data="cameraList"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
          size="small">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="camera_id" label="ID" width="80" align="center"></el-table-column>
          <el-table-column prop="name" label="摄像头名称" min-width="150" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column prop="type" label="摄像头类型" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.type === '1' ? 'primary' : 'success'" size="small">
                {{ scope.row.type === '1' ? '平台摄像头' : '工厂摄像头' }}
              </el-tag>
            </template>
          </el-table-column> -->
          <el-table-column prop="status" label="启用状态" width="100" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                :active-value="2"
                :inactive-value="1"
                @change="handleStatusChange(scope.row)"
                active-color="#13ce66">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="deviceSerial" label="序列号" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="code" label="code" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="channelNo" label="通道" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="sort" label="排序" width="80" align="center"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="160" align="center"></el-table-column>
          <el-table-column label="操作" width="200" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
          </el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 申请查看 -->
    <div v-if="activeName === 'apply'" class="apply-content" key="apply-content">
      <!-- 统计卡片 -->
      <el-row :gutter="20" class="stats-row">
        <el-col :span="6">
          <el-card class="stats-card" shadow="hover">
            <div class="stats-item">
              <div class="stats-icon total">
                <i class="el-icon-document"></i>
              </div>
              <div class="stats-info">
                <div class="stats-value">{{ applyStats.total || 0 }}</div>
                <div class="stats-label">总申请数</div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="stats-card" shadow="hover">
            <div class="stats-item">
              <div class="stats-icon pending">
                <i class="el-icon-time"></i>
              </div>
              <div class="stats-info">
                <div class="stats-value">{{ applyStats.pending || 0 }}</div>

                <div class="stats-label">待审核</div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="stats-card" shadow="hover">
            <div class="stats-item">
              <div class="stats-icon approved">
                <i class="el-icon-success"></i>
              </div>
              <div class="stats-info">
                <div class="stats-value">{{ applyStats.approved || 0 }}</div>
                <div class="stats-label">已通过</div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="stats-card" shadow="hover">
            <div class="stats-item">
              <div class="stats-icon rejected">
                <i class="el-icon-error"></i>
              </div>
              <div class="stats-info">
                <div class="stats-value">{{ applyStats.rejected || 0 }}</div>
                <div class="stats-label">已拒绝</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 搜索区域 -->
      <el-card class="search-card">
        <el-form :inline="true" :model="applySearchForm" size="small" class="search-form">
          <el-form-item label="申请状态">
            <el-select v-model="applySearchForm.status" placeholder="请选择状态" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="待审核" value="0"></el-option>
              <el-option label="已通过" value="1"></el-option>
              <el-option label="已拒绝" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户ID">
            <el-input v-model="applySearchForm.user_id" placeholder="请输入用户ID" clearable></el-input>
          </el-form-item>
          <el-form-item label="动态码">
            <el-input v-model="applySearchForm.dy_code" placeholder="请输入动图码" clearable></el-input>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker
              v-model="applySearchForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleApplySearch">查询</el-button>
            <el-button @click="resetApplySearch">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <!-- 申请列表 -->
      <el-card>
        <el-table
          v-loading="applyLoading"
          :data="applyList"
          border
          style="width: 100%"
          @selection-change="handleApplySelectionChange"
          size="small">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="camera_apply_id" label="申请ID" width="80" align="center"></el-table-column>
          <el-table-column prop="nickName" label="用户名" width="100" align="center"></el-table-column>
          <el-table-column prop="company" label="公司" width="100" align="center"></el-table-column>
          <el-table-column prop="apply_reason" label="申请原因" width="100" align="center"></el-table-column>
          <el-table-column prop="dy_code" label="动态码" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="申请状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="getApplyStatusType(scope.row.status)" size="small">
                {{ formatApplyStatus(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="valid_time" label="有效期至" width="120" align="center">
            <template slot-scope="scope">
              {{ scope.row.valid_time || '永久' }}
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" width="80" align="center"></el-table-column>
          <el-table-column prop="create_time" label="申请时间" width="160" align="center"></el-table-column>
          <el-table-column prop="update_time" label="更新时间" width="160" align="center"></el-table-column>
          <el-table-column label="操作" width="180" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button 
                v-if="scope.row.status == 0" 
                type="success" 
                size="mini" 
                 class="member-btn"
                @click="handleApplyAction(scope.row, 1)">

                  <span v-if="scope.row.is_read == 0" class="unread-dot-member"></span>
                通过
              </el-button>
              <el-button 
                v-if="scope.row.status == 0" 
                type="danger" 
                size="mini" 
                 class="member-btn"
                @click="handleApplyAction(scope.row, 2)">
                  <span v-if="scope.row.is_read == 0" class="unread-dot-member"></span>
                拒绝
              </el-button>
              <el-button 
                type="primary" 
                size="mini" 
                @click="viewApplyDetail(scope.row)">
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            background
            @size-change="handleApplySizeChange"
            @current-change="handleApplyCurrentChange"
            :current-page="applyPagination.current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="applyPagination.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="applyPagination.total">
          </el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 添加/编辑摄像头弹窗 -->
    <el-dialog
      :title="cameraDialog.title"
      :visible.sync="cameraDialog.visible"
      width="600px"
      :close-on-click-modal="false"
      @closed="handleCameraDialogClosed">
      <el-form ref="cameraForm" :model="cameraForm" :rules="cameraRules" label-width="100px" size="small">
        <el-form-item label="摄像头名称" prop="name">
          <el-input v-model="cameraForm.name" placeholder="请输入摄像头名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="摄像头类型" prop="type">
          <el-radio-group v-model="cameraForm.type">
            <el-radio label="1">平台摄像头</el-radio>
            <el-radio label="2">工厂摄像头</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="序列号" prop="deviceSerial">
          <el-input v-model="cameraForm.deviceSerial" placeholder="请输入序列号"></el-input>
        </el-form-item>
        <el-form-item label="code" prop="code">
          <el-input v-model="cameraForm.code" placeholder="请输入code"></el-input>
        </el-form-item>
        <el-form-item label="通道" prop="channelNo">
          <el-input v-model="cameraForm.channelNo" placeholder="请输入通道"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="cameraForm.sort" :min="0" :max="999"></el-input-number>
        </el-form-item>
        <el-form-item label="启用状态" prop="status">
          <el-switch
            v-model="cameraForm.status"
            :active-value="2"
            :inactive-value="1"
            active-text="开启"
            inactive-text="关闭">
          </el-switch>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            v-model="cameraForm.description"
            type="textarea"
            :rows="3"
            placeholder="请输入摄像头描述">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cameraDialog.visible = false" size="small">取消</el-button>
        <el-button type="primary" @click="submitCameraForm" :loading="cameraLoading" size="small">确定</el-button>
      </div>
    </el-dialog>

    <!-- 申请详情弹窗 -->
    <el-dialog
      title="申请详情"
      :visible.sync="applyDetailDialog.visible"
      width="500px"
      :close-on-click-modal="false">
      <el-descriptions :column="1" border size="small" v-if="applyDetailDialog.data">
        <el-descriptions-item label="申请ID">{{ applyDetailDialog.data.camera_apply_id }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{ applyDetailDialog.data.user_id }}</el-descriptions-item>
        <el-descriptions-item label="抖音码">{{ applyDetailDialog.data.dy_code }}</el-descriptions-item>
        <el-descriptions-item label="申请状态">
          <el-tag :type="getApplyStatusType(applyDetailDialog.data.status)" size="small">
            {{ formatApplyStatus(applyDetailDialog.data.status) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="有效期至">{{ applyDetailDialog.data.valid_time || '永久' }}</el-descriptions-item>
        <el-descriptions-item label="排序">{{ applyDetailDialog.data.sort }}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{ applyDetailDialog.data.create_time }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ applyDetailDialog.data.update_time }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="applyDetailDialog.visible = false" size="small">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CameraApi from '@/api/camera.js';

export default {
  name: 'CameraManage',
  data() {
    return {
      activeName: 'apply',
      cameranum:{},
      
      // 折叠状态
      basicConfigCollapsed: false,
      infoConfigCollapsed: false,
      
      // 摄像头设置相关
      settingForm: {
        status: false,
        AppKey: '',
        Secret: '',
        AccessToken: '',
        test_url: '',
        callback_url: '',
        valid_duration: 5 // 默认5分钟
      },
      settingRules: {
        AppKey: [
          { required: true, message: '请输入AppKey', trigger: 'blur' }
        ],
        Secret: [
          { required: true, message: '请输入Secret', trigger: 'blur' }
        ]
      },
      settingLoading: false,

      // 其他数据保持不变...
      searchForm: {
        name: '',
        type: '',
        status: ''
      },
      listLoading: false,
      cameraList: [],
      selectedCameras: [],
      pagination: {
        current: 1,
        size: 20,
        total: 0
      },
      applySearchForm: {
        status: '',
        user_id: '',
        dy_code: '',
        dateRange: []
      },
      applyLoading: false,
      applyList: [],
      selectedApplies: [],
      applyStats: {},
      applyPagination: {
        current: 1,
        size: 20,
        total: 0
      },
      cameraDialog: {
        visible: false,
        title: '添加摄像头',
        type: 'add'
      },
      cameraForm: {
        camera_id: '',
        name: '',
        type: '1',
        deviceSerial: '',
        channelNo: '',
        code:'',
        sort: 1,
        status: 1,
        description: ''
      },
      cameraRules: {
        name: [
          { required: true, message: '请输入摄像头名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择摄像头类型', trigger: 'change' }
        ],
        deviceSerial: [
          { required: true, message: '请输入序列号', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入code', trigger: 'blur' }
        ]
      },
      cameraLoading: false,
      applyDetailDialog: {
        visible: false,
        data: null
      },
      supply_id: 0
    };
  },
  created() {
    this.supply_id = this.$route.query.supply_id || 0;
    // 替换原有初始化逻辑，使用统一的initTabData方法
    this.initTabData();
  },
  methods: {
    // 新增：初始化Tab数据
    initTabData() {
      this.loadSetting(); // 始终加载设置数据（因为是共用的配置）
      this.getCameranum();
      
      // 根据当前激活的tab加载对应数据
      if (this.activeName === 'apply') {
        this.loadApplyList();
        this.loadApplyStats();
      } else if (this.activeName === 'list') {
        this.loadCameraList();
      }
    },

    // 新增方法：切换基础配置折叠状态
    toggleBasicConfig() {
      this.basicConfigCollapsed = !this.basicConfigCollapsed;
    },

    // 新增方法：切换配置说明折叠状态
    toggleInfoConfig() {
      this.infoConfigCollapsed = !this.infoConfigCollapsed;
    },

    // 新增方法：格式化时长显示
    formatDuration(minutes) {
      if (minutes < 60) {
        return `${minutes}分钟`;
      } else if (minutes < 1440) {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return mins > 0 ? `${hours}小时${mins}分钟` : `${hours}小时`;
      } else {
        const days = Math.floor(minutes / 1440);
        const hours = Math.floor((minutes % 1440) / 60);
        if (hours > 0) {
          return `${days}天${hours}小时`;
        } else {
          return `${days}天`;
        }
      }
    },

    // 修复Tab切换逻辑
    handleTabClick(tab) {
      this.activeName = tab.name; // 确保activeName同步更新
      
      // 根据不同的tab执行不同的初始化逻辑
      switch (tab.name) {
        case 'apply':
          this.loadApplyList();
          this.loadApplyStats();
          break;
        case 'list':
          this.loadCameraList();
          this.getCameranum(); // 刷新摄像头数量统计
          break;
        case 'setting':
          this.loadSetting(); // 重新加载设置数据确保最新
          break;
      }
    },
    async getCameranum(){
        const res = await CameraApi.getCameranum({ supply_id: this.supply_id })
        this.cameranum = res.data
    },

    // ========== 摄像头设置相关方法 ==========
    async loadSetting() {
      try {
        const response = await CameraApi.getSetting({ supply_id: this.supply_id });
        if (response.code === 1 && response.data.vars.values) {
          this.settingForm = { ...this.settingForm, ...response.data.vars.values };
        }
      } catch (error) {
        this.$message.error('加载配置失败');
      }
    },

    saveSetting() {
      this.$refs.settingForm.validate(async (valid) => {
        if (valid) {
          this.settingLoading = true;
          try {
            const params = { ...this.settingForm, supply_id: this.supply_id };
            const response = await CameraApi.saveSetting(params);
            if (response.code === 1) {
              this.$message.success('保存成功');
            } else {
              this.$message.error(response.msg || '保存失败');
            }
          } catch (error) {
            this.$message.error('保存失败');
          } finally {
            this.settingLoading = false;
          }
        }
      });
    },

   resetSetting() {
  this.settingForm = {
    status: false,
    AppKey: '',
    Secret: '',
    AccessToken: '',
    test_url: '',
    callback_url: '',
    valid_duration: 5 // 重置时设为默认值
  };
},

    generateAppKey() {
      this.settingForm.AppKey = this.generateRandomString(32);
    },

    generateSecret() {
      this.settingForm.Secret = this.generateRandomString(64);
    },

    async refreshToken() {
      try {
        const response = await CameraApi.refreshToken({ supply_id: this.supply_id });
        if (response.code === 1) {
          this.settingForm.AccessToken = response.data.access_token;
          this.$message.success('Token刷新成功');
        } else {
          this.$message.error(response.msg || '刷新失败');
        }
      } catch (error) {
        this.$message.error('刷新失败');
      }
    },

    async testConnection() {
      try {
        const response = await CameraApi.testConnection({ supply_id: this.supply_id });
        if (response.code === 1) {
          this.$message.success('连接测试成功');
        } else {
          this.$message.error(response.msg || '连接测试失败');
        }
      } catch (error) {
        this.$message.error('连接测试失败');
      }
    },

    // 其他方法保持不变...
    async loadCameraList() {
      this.listLoading = true;
      try {
        const params = {
          ...this.searchForm,
          page: this.pagination.current,
          list_rows: this.pagination.size,
          supply_id: this.supply_id
        };
        const response = await CameraApi.list(params);
        if (response.code === 1) {
          this.cameraList = response.data.list.data;
          this.pagination.total = response.data.list.total;
        } else {
          this.$message.error(response.msg || '加载失败');
        }
      } catch (error) {
        this.$message.error('加载失败');
      } finally {
        this.listLoading = false;
      }
    },

    handleSearch() {
      this.pagination.current = 1;
      this.loadCameraList();
    },

    resetSearch() {
      this.searchForm = {
        name: '',
        type: '',
        status: ''
      };
      this.pagination.current = 1;
      this.loadCameraList();
    },

    handleAdd() {
      if (this.cameranum.camera_num >= this.cameranum.user_sxt) {
        this.$message.warning(`摄像头数量已达上限，当前已添加 ${this.cameranum.camera_num} 个，最多可添加 ${this.cameranum.user_sxt} 个`);
        return;
      }
      
      this.cameraDialog = {
        visible: true,
        title: '添加摄像头',
        type: 'add'
      };
      this.cameraForm = {
        camera_id: '',
        name: '',
        type: '1',
        identify_code: '',
        channelNo: '',
        code:'',
        sort: 1,
        status: 1,
        description: ''
      };
    },

    handleEdit(row) {
      this.cameraDialog = {
        visible: true,
        title: '编辑摄像头',
        type: 'edit'
      };
      this.cameraForm = { ...row };
    },

    async handleStatusChange(row) {
      try {
        const response = await CameraApi.updateStatus({
          camera_id: row.camera_id,
          status: row.status
        });
        if (response.code === 1) {
          this.$message.success('状态更新成功');
        } else {
          this.$message.error(response.msg || '状态更新失败');
          row.status = row.status === 1 ? 2 : 1;
        }
      } catch (error) {
        console.log(error,'error')
        this.$message.error('状态更新失败');
        row.status = row.status === 1 ? 2 : 1;
      }
    },

    handleDelete(row) {
      this.$confirm('确定要删除这个摄像头吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await CameraApi.del({ camera_id: row.camera_id });
          if (response.code === 1) {
            this.$message.success('删除成功');
            await this.getCameranum();
            this.loadCameraList();
          } else {
            this.$message.error(response.msg || '删除失败');
          }
        } catch (error) {
          this.$message.error('删除失败');
        }
      });
    },

    submitCameraForm() {
      this.$refs.cameraForm.validate(async (valid) => {
        if (valid) {
          if (this.cameraDialog.type === 'add') {
            await this.getCameranum();
            
            if (this.cameranum.camera_num >= this.cameranum.user_sxt) {
              this.$message.warning(`摄像头数量已达上限，当前已添加 ${this.cameranum.camera_num} 个，最多可添加 ${this.cameranum.user_sxt} 个`);
              return;
            }
          }
          
          this.cameraLoading = true;
          try {
            const params = { ...this.cameraForm, supply_id: this.supply_id };
            const api = this.cameraDialog.type === 'add' ? CameraApi.add : CameraApi.edit;
            const response = await api(params);
            if (response.code === 1) {
              this.$message.success(this.cameraDialog.type === 'add' ? '添加成功' : '更新成功');
              this.cameraDialog.visible = false;
              await this.getCameranum();
              this.loadCameraList();
            } else {
              this.$message.error(response.msg || '操作失败');
            }
          } catch (error) {
            this.$message.error('操作失败');
          } finally {
            this.cameraLoading = false;
          }
        }
      });
    },

    handleCameraDialogClosed() {
      this.$refs.cameraForm.clearValidate();
    },

    async loadApplyList() {
      this.applyLoading = true;
      try {
        const params = {
          ...this.applySearchForm,
          page: this.applyPagination.current,
          list_rows: this.applyPagination.size,
          supply_id: this.supply_id
        };
        
        if (this.applySearchForm.dateRange && this.applySearchForm.dateRange.length === 2) {
          params.start_time = this.applySearchForm.dateRange[0];
          params.end_time = this.applySearchForm.dateRange[1];
        }

        const response = await CameraApi.getApplyList(params);
        if (response.code === 1) {
          this.applyList = response.data.list.data;
          this.applyPagination.total = response.data.list.total;
        } else {
          this.$message.error(response.msg || '加载失败');
        }
      } catch (error) {
        this.$message.error('加载失败');
      } finally {
        this.applyLoading = false;
      }
    },

    async loadApplyStats() {
      try {
        const response = await CameraApi.getApplyStats({ supply_id: this.supply_id });
        if (response.code === 1) {
          this.applyStats = response.data;
        }
      } catch (error) {
        console.error('加载统计失败:', error);
      }
    },

    handleApplySearch() {
      this.applyPagination.current = 1;
      this.loadApplyList();
    },

    resetApplySearch() {
      this.applySearchForm = {
        status: '',
        user_id: '',
        dy_code: '',
        dateRange: []
      };
      this.applyPagination.current = 1;
      this.loadApplyList();
    },

    async handleApplyAction(row, status) {
      const action = status === 1 ? '通过' : '拒绝';
      this.$confirm(`确定要${action}此申请吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await CameraApi.handleApply({
            camera_apply_id: row.camera_apply_id,
            status: status
          });
          if (response.code === 1) {
            this.$message.success(`${action}成功`);
            this.loadApplyList();
            this.loadApplyStats();
          } else {
            this.$message.error(response.msg || `${action}失败`);
          }
        } catch (error) {
          this.$message.error(`${action}失败`);
        }
      });
    },

    viewApplyDetail(row) {
      this.applyDetailDialog = {
        visible: true,
        data: row
      };
    },

    handleApplySelectionChange(selection) {
      this.selectedApplies = selection;
    },

    handleApplySizeChange(size) {
      this.applyPagination.size = size;
      this.applyPagination.current = 1;
      this.loadApplyList();
    },

    handleApplyCurrentChange(current) {
      this.applyPagination.current = current;
      this.loadApplyList();
    },

    formatApplyStatus(status) {
      const statusMap = {
        '0': '待审核',
        '1': '已通过',
        '2': '已拒绝'
      };
      return statusMap[status] || '未知';
    },

    getApplyStatusType(status) {
      const typeMap = {
        '0': 'warning',
        '1': 'success',
        '2': 'danger'
      };
      return typeMap[status] || 'info';
    },

    generateRandomString(length) {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    },

    // 补充缺失的方法
    refreshList() {
      this.loadCameraList();
    },
    handleSizeChange(size) {
      this.pagination.size = size;
      this.pagination.current = 1;
      this.loadCameraList();
    },
    handleCurrentChange(current) {
      this.pagination.current = current;
      this.loadCameraList();
    },
    handleSelectionChange(selection) {
      this.selectedCameras = selection;
    }
  }
};
</script>

<style scoped>
.camera-manage-container {
  padding: 20px;
  background: #f5f5f5;
  min-height: calc(100vh - 84px);
}

/* 可折叠卡片头部样式 */
.collapsible {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
}

.collapse-icon {
  transition: transform 0.3s;
  font-size: 16px;
  color: #909399;
}

.collapsible:hover .collapse-icon {
  color: #409EFF;
}

/* 卡片样式 */
.setting-card,
.duration-card,
.action-card,
.search-card,
.info-card {
  margin-bottom: 20px;
}

.card-header {
  font-weight: bold;
  font-size: 16px;
}

/* 公用保存按钮样式 */
.action-card .action-buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
}

/* 其他样式保持不变 */
.search-form {
  margin-bottom: 0;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.stats-row {
  margin-bottom: 20px;
}

.stats-card {
  border-radius: 8px;
}

.stats-item {
  display: flex;
  align-items: center;
}

.stats-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  font-size: 24px;
  color: white;
}

.stats-icon.total {
  background: #409EFF;
}

.stats-icon.pending {
  background: #E6A23C;
}

.stats-icon.approved {
  background: #67C23A;
}

.stats-icon.rejected {
  background: #F56C6C;
}

.stats-info {
  flex: 1;
}

.stats-value {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
}

.stats-label {
  font-size: 14px;
  color: #909399;
}

.info-content {
  color: #606266;
  line-height: 1.6;
}

.info-content p {
  margin: 5px 0;
}

.el-table {
  margin-top: 0;
}

.camera-count-info {
  margin-left: auto;
}

@media (max-width: 768px) {
  .camera-manage-container {
    padding: 10px;
  }
  
  .stats-row .el-col {
    margin-bottom: 10px;
  }
  
  .action-buttons {
    flex-wrap: wrap;
  }
  
  .collapsible {
    font-size: 14px;
  }
}
/* 可以根据需要添加样式 */
  .member-btn {
  position: relative;
}

/* 会员未读红点样式 */
.unread-dot-member {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background-color: #ff4757;
  border-radius: 50%;
  animation: pulse 2s infinite;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/camera/index/index.vue